import { render, staticRenderFns } from "./IndivualRatesModel.vue?vue&type=template&id=50073410"
import script from "./IndivualRatesModel.vue?vue&type=script&lang=js"
export * from "./IndivualRatesModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports